// src/components/ManageDomains.js

import React, { useState, useEffect } from 'react';
import {
  collection,
  query,
  getDocs,
  getDoc,
  addDoc,
  deleteDoc,
  doc,
  setDoc,
} from 'firebase/firestore';
import { auth, dbFirestore, signOut } from '../firebase';
import Notification from '../Notification';
import { useNavigate, Link } from "react-router-dom";
import "./ManageDomains.css";
import { Icon } from '@iconify/react';
import LoadingSpinner from '../LoadingSpinner';
import { type } from '@testing-library/user-event/dist/cjs/utility/type.js';


const profileStyle = {
  backgroundColor: '#ffffff', // Replace with your desired background color
};

function ManageDomains() {
  const [user, setUser] = useState(null);
 
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const [txtRecord, setTxtRecord] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const [notification, setNotification] = useState(null);


  const [selectedCategory, setSelectedCategory] = useState(null);

  const [numeric, setNumeric] = useState('');

  const [editingRowId, setEditingRowId] = useState(null);
  const [editedDomain, setEditedDomain] = useState(null);

  const [domains, setDomains] = useState([]);
  const [newDomain, setNewDomain] = useState({
    // Your domain properties here
  });
  const [showEmptyRow, setShowEmptyRow] = useState(false);





  
    const [publicDomains, setPublicDomains] = useState([]); // Define publicDomains state
    const [allUserDomains, setAllUserDomains] = useState([]); // Define allUserDomains state
  
   
    const [isFiltering, setIsFiltering] = useState(false);
    const [showGeneralButton, setShowGeneralButton] = useState(true);
  
  
    const [filteredDomainsAll, setFilteredDomainsAll] = useState([]);
    const [nameFilter, setNameFilter] = useState('');
    const [organisationFilter, setOrganisationFilter] = useState('');
    const [locationFilter, setLocationFilter] = useState('');
    const [closingDateFilter, setClosingDateFilter] = useState('');
    const [searchType, setSearchType] = useState('All'); // Default to 'All' for type
    const [searchPostType, setSearchPostType] = useState('All'); // Default to 'All' for type
    const [searchCurrency, setSearchCurrency] = useState('All');
    const [minNumeric, setMinNumeric] = useState('');
    const [maxNumeric, setMaxNumeric] = useState('');
    
    const [searchCategory, setSearchCategory] = useState('All'); // Default to 'All' for category
    
    const [isFilteringActive, setIsFilteringActive] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
  
  
    const [userId, setUserId] = useState(null);
  
   
   
    const itemsPerPage = window.innerWidth <= 768 ? 8 : 6;
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(itemsPerPage);
  
    const [randomizedDomains, setRandomizedDomains] = useState([]);
    const [randomizedFilteredDomains, setRandomizedFilteredDomains] = useState([]);
  
    const [expandedRows, setExpandedRows] = useState({});
    
    const [showSmallScreenMenu, setShowSmallScreenMenu] = useState(false);
  
    const [hideHeader, setHideHeader] = useState(false);
    const isBigScreen = window.innerWidth > 480;

  useEffect(() => {
    // Listen for authentication state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, update the user state
        setUser(user);
      } else {
        // User is signed out, redirect to sign-in page
        navigate('/sign-in'); // Replace '/signin' with your actual sign-in route
      }
    });

    // Clean up the subscription to avoid memory leaks
    return () => unsubscribe();
  }, [navigate]);

   // Function to handle user logout
   const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/sign-in'); // Redirect to the login page after logout
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };


  const fetchDomains = async () => {
    try {
      if (user) {
        const userDomainsRef = collection(dbFirestore, 'users', user.uid, 'domains');
        const q = query(userDomainsRef);
        const querySnapshot = await getDocs(q);
        const domainsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDomains(domainsData);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching domains:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchDomains();
    }
  }, [user]);

  

  const addDomain = async () => {
    if (user && user.uid) {
      try {
       
  
        // Create a reference to the 'domains' collection under the user's UID
        const userDomainsRef = collection(dbFirestore, 'users', user.uid, 'domains');
  
        const domainToAdd = {
          organisationName: newDomain.organisationName || '',
          domainName: newDomain.domainName || '',
          price: newDomain.price || '',
          currency: newDomain.currency || '',
          numeric: newDomain.numeric || '',
          category: newDomain.category || '',
          type: newDomain.type || '',
          postType: newDomain.postType || '',
          jobLocation: newDomain.jobLocation || '',
          closingDate: newDomain.closingDate || '',
          jobUrl: newDomain.jobUrl || '',
          description: newDomain.description || '',
          dateListed: getCurrentFormattedDate(),
          isPublic: false,
          ownerId: user.uid,
          isVerified: false,
         
        };
  
        // Add the domain to Firestore
        const docRef = await addDoc(userDomainsRef, domainToAdd);
  
        // Fetch updated domains and update state
        fetchDomains();
  
        // Reset form fields and state
        setShowEmptyRow(true);

        setEditingRowId(docRef.id);
      setEditedDomain({ ...domainToAdd, id: docRef.id });

        setNewDomain({
          organisationName: '',
          domainName: '',
          price: '',
          currency: '',
          numeric: '',
          category: '',
          type: '',
          postType: '',
          jobLocation: '',
          jobUrl: '',
          closingDate: '',
          description: '',
          isVariousPosition: '',
          isSpecificPosition: '',
        });
      } catch (error) {
        console.error('Error adding domain:', error);
      }
    } else {
      console.error('User or User ID is not available.');
    }
  };

  
    

  const removeDomain = async (domainId) => {
    if (user) {
      const userDomainDocRef = doc(dbFirestore, 'users', user.uid, 'domains', domainId);

      try {
        await deleteDoc(userDomainDocRef);
        fetchDomains();
        setNotification('Domain was successfully removed');
      } catch (error) {
        setNotification('Error in removing domain');
        console.error('Error removing domain:', error);
      }
    }
  };

 
const handleSaveRowChanges = async () => {
  if (user && editingRowId) {
    try {
      const userDomainDocRef = doc(
        dbFirestore,
        'users',
        user.uid,
        'domains',
        editingRowId
      );

      await setDoc(userDomainDocRef, editedDomain, { merge: true });

      fetchDomains();
      setEditingRowId(null); // Exit edit mode
      setEditedDomain(null);
      setNotification('Changes were successfully saved.');
    } catch (error) {
      console.error('Error saving changes:', error);
    }
  }
};

const getCurrentFormattedDate = () => {
  const options = { day: "numeric", month: "short", year: "numeric" };
  return new Date().toLocaleDateString(undefined, options);
};


const getFormattedDate = (dateString) => {
  if (!dateString) return "Various/ Not specified"; // Handle empty or undefined dates
  const date = new Date(dateString);

  // Extract day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g., Jan, Feb
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};



  const handleInputChange = (event, domainId, field) => {
    if (field === 'category') {
      const selectedCategory = event.target.value;
      console.log('Selected Category:', selectedCategory);
      setSelectedCategory(selectedCategory); // Update the selected category in state
  
      // Update the category property of the domain
      const updatedDomains = domains.map((domain) => {
        if (domain.id === domainId) {
          return {
            ...domain,
            category: selectedCategory,
          };
        }
        return domain;
      });
      setDomains(updatedDomains);
    } else {
      const updatedDomains = domains.map((domain) => {
        if (domain.id === domainId) {
          return {
            ...domain,
            [field]: event.target.value,
          };
        }
        return domain;
      });
      setDomains(updatedDomains);
    }
  };

  const handleNumericInputChange = (event, domainId) => {
    const enteredValue = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
    const numericValue = enteredValue !== '' ? parseInt(enteredValue, 10) : '';
    const formattedValue = numericValue ? numericValue.toLocaleString('en-US') : '';
    const updatedDomains = domains.map((domain) => {
      if (domain.id === domainId) {
        return {
          ...domain,
          numeric: formattedValue,
        };
      }
      return domain;
    });
    setDomains(updatedDomains);
  };
 
  
  const handleEditClick = (domain) => {
    setEditingRowId(domain.id);
    setEditedDomain(domain);
  };

  
  const handleTogglePublicStatus = async (domainId, currentStatus) => {
    if (user) {
      const userDomainDocRef = doc(dbFirestore, 'users', user.uid, 'domains', domainId);
  
      try {
        // Toggle the isPublic status
        await setDoc(userDomainDocRef, { isPublic: !currentStatus }, { merge: true });
        fetchDomains(); // Re-fetch domains to reflect the update
        setNotification('Public status updated successfully.');
      } catch (error) {
        console.error('Error updating public status:', error);
        setNotification('Error updating public status');
      }
    }
  }; 
 
  // Render the table rows
  const renderTableRows = () => {
    if (editingRowId) {
      return (
        <div>
          <input
            type="text"
            placeholder="Organisation name"
            value={editedDomain?.organisationName || ''}
            onChange={(e) => setEditedDomain({ ...editedDomain, organisationName: e.target.value })}
          />
          <input
          type="text"
          placeholder="Job title"
          value={editedDomain?.domainName || ''}
          onChange={(e) => setEditedDomain({ ...editedDomain, domainName: e.target.value })}
        />

<select
          value={editedDomain?.currency || ''}
          onChange={(e) => setEditedDomain({ ...editedDomain, currency: e.target.value })}
        >
          <option value="">Select Currency</option>
          <option value="Not Disclosed">Not disclosed</option>
          <option value="R">R /South African Rand</option>
          <option value="$">$/ USD /US Dollar</option>
          <option value="€">€/ EUR /Euro</option>
          <option value="£">£/ GBP /British Pound</option>
          <option value="¥">¥ /Yen</option>
          <option value="₣">₣ /Franc</option>
          <option value="₹">₹ /Rupee</option>
          <option value="₽">₽ /RUB /Russian Ruble</option>
          <option value="A$">A$ /AUD /Australian Dollar</option>
          <option value="C$">C$ /CAD /Canadian dollar</option>
          <option value="HK$">HK$ /Hong Kong Dollar</option>
          <option value="R$">R$ /BRL /Brazilian real</option>
          <option value="Mex$">Mex$ /MXN /Mexican Peso</option>
        
          <option value="د.إ"> د.إ /Dirham</option>
          <option value="د.ك"> د.ك /Dinar</option>
          <option value="Multiple">Multiple</option>
          
        </select>
      
        <input
            type="text"
            placeholder="Enter annual amount"
            value={editedDomain?.numeric || ''}
            onChange={(e) => setEditedDomain({ ...editedDomain, numeric: e.target.value })}
          />
        <select
           value={editedDomain?.type || ''}
           onChange={(e) => setEditedDomain({ ...editedDomain, type: e.target.value })}
        >
          <option value="">Select Type</option>
          <option value="Full-Time">Full-Time</option>
          <option value="Part-Time">Part-Time</option>
          <option value="Freelance">Freelance</option>
          <option value="Contract">Contract</option>
          <option value="Internship">Internship</option>
          <option value="Learnership">Learnership</option>
          <option value="Multiple">Multiple</option>
        </select>

        <select
           value={editedDomain?.category || ''}
           onChange={(e) => setEditedDomain({ ...editedDomain, category: e.target.value })} 
           >
          <option value="">Select Industry</option>
          <option value="Government">Government</option>
          <option value="Retail">Retail</option>
          <option value="Banking">Banking</option>
          <option value="Mining">Mining</option>
          <option value="Technology">Technology</option>
      
          <option value="Sport">Sport</option>
          <option value="Entertainment">Entertainment</option>
          <option value="Blog">Blog</option>
          <option value="Finance">Finance</option>
          <option value="Travel and Hospitality">Travel and Hospitality</option>
          <option value="Education and Academic">Education and Academic</option>
          <option value="Health">Health</option>
          <option value="Telecommunication">Telecommunication</option>
          <option value="Internet services">Internet services</option>
          <option value="Design">Design</option>
          <option value="E-commerce and Online Stores">E-commerce and Online Stores</option>
          <option value="Business">Business</option>
          <option value="Non-profit">Non-profit</option>
          <option value="Other">Other</option>
          {/* Add more options as needed */}
        </select>
        <input
          type="text"
          placeholder="Job location"
          value={editedDomain?.jobLocation || ''}
          onChange={(e) => setEditedDomain({ ...editedDomain, jobLocation: e.target.value })} 
        />

<input
    type="date"  
    pvalue={editedDomain?.closingDate || ''}
    onChange={(e) => setEditedDomain({ ...editedDomain, closingDate: e.target.value })} laceholder="Select job date"
  />
   <select
          value={editedDomain?.postType || ''}
          onChange={(e) => setEditedDomain({ ...editedDomain, postType: e.target.value })} 
        >
          <option value="">Select Post Type</option>
          <option value="Various Positions">Various Positions</option>
          <option value="Specific Position">Specific Position</option>
        </select>
<input
          type="url"
          placeholder="Paste job link"
          value={editedDomain?.jobUrl || ''}
           onChange={(e) => setEditedDomain({ ...editedDomain, jobUrl: e.target.value })} 
        />

          <button style={saveChangesbtnStyle} onClick={handleSaveRowChanges}>Save Changes</button>
          <button style={editDomainbtnStyle} onClick={() => setEditingRowId(null)}>Cancel changes</button>
          <button
            style={removeDomainbtnStyle}
            onClick={() => removeDomain(editedDomain?.id)} // Use the id from editedDomain, not domain
          >
            Delete post
          </button>

        </div>
      );
    }
  
  
  
    return (
      <table>
        <tbody>
          {domains.map((domain) => (
            <tr key={domain.id}>
              <td>{domain.organisationName}</td>
              <td>
                <button onClick={() => handleEditClick(domain)}>Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  
const allDomains = [...publicDomains, ...allUserDomains];

const logoutStyle = {
  margin: '5px',
  padding: '6px 12px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: '#4f4f4f',
  color: 'white',
  cursor: 'pointer'
};

const editDomainbtnStyle = {
  margin: '5px',
  padding: '4px 8px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: '#4f4f4f',
  color: 'white',
  cursor: 'pointer'
};


const removeDomainbtnStyle = {
  margin: '5px',
  padding: '4px 8px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: 'red',
  color: 'white',
  cursor: 'pointer'
};

const saveChangesbtnStyle = {
  margin: '5px',
  padding: '4px 8px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: 'blue',
  color: 'white',
  cursor: 'pointer'
};

const addDomainbtnStyle = {
  margin: '5px',
  padding: '6px 12px',
  fontSize: '12px',
  border: 'none',
  borderRadius: '5px',
  backgroundColor: '#4f4f4f',
  color: 'white',
  cursor: 'pointer'
};

const tableStyle = {
  borderCollapse: 'collapse',
  width: '100%',
};

const thStyle = {
  backgroundColor: '#f0f0f0',
  padding: '8px',
  textAlign: 'left',
  borderBottom: '1px solid #ddd',

  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '200px', // Default maxWidth for larger screens
};

const tdStyle = {
  padding: '8px',
  borderBottom: '1px solid #ddd',
  backgroundColor: '#ffffff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '200px', // Default maxWidth for larger screens
};

// Media query to adjust styles for smaller screens
if (window.innerWidth <= 768) {
  tdStyle.maxWidth = '120px'; // Adjust maxWidth for smaller screens
  thStyle.maxWidth = '150px'; // Adjust maxWidth for smaller screens
}


const TooltipbtnStyle = {
  backgroundColor: '#eeeeee',
  color: '#000000',
  padding: '2px 4px', // Adjust padding as needed for your content
  border: 'none',
  borderRadius: '5px', // Border radius for rounded corners
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center', // Center content vertically
  justifyContent: 'center', // Center content horizontally
 
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Optional box shadow for a raised effect
};


const NxtNavbuttonStyle = {

position: 'absolute',

right: '10px',


alignItems: 'center',
justifyContent: 'center',
textAlign: 'right', 

  margin: '0 5px', // Margin between buttons
  padding: '8px', // Padding inside buttons
  cursor: 'pointer', // Cursor style
};

const PreNavbuttonStyle = {

  position: 'absolute',

right: '40px',


alignItems: 'center',
justifyContent: 'center',
textAlign: 'right', 

  margin: '0 5px', // Margin between buttons
  padding: '8px', // Padding inside buttons
  cursor: 'pointer', // Cursor style
};

const disabledNxtNavButtonStyle = {
  ...NxtNavbuttonStyle,

  cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
  color: 'grey', // Set text color to grey for disabled buttons

alignItems: 'center',
justifyContent: 'center',
};

const disabledPreNavButtonStyle = {
  ...PreNavbuttonStyle,

  cursor: 'not-allowed', // Change cursor to not-allowed for disabled buttons
  color: 'grey', // Set text color to grey for disabled buttons

alignItems: 'center',
justifyContent: 'center',
};


const NaviconStyle = {
  marginRight: '5px', // Margin between icon and text
};

  // Sort the domains by timestamp in descending order
  const sortedDomains = domains.slice().sort((a, b) => {
    // Assuming each domain entry has a timestamp field called 'timestamp'
    return new Date(b.dateListed) - new Date(a.dateListed);
  });
 
    const domainsToDisplay = sortedDomains.slice(startIndex, endIndex);


const filteredDomainsToRender = isFilteringActive ? filteredDomainsAll : allDomains;

const filteredDomainsToDisplay = randomizedFilteredDomains.slice(startIndex, endIndex);



const handlePreviousPage = () => {
  const newStartIndex = Math.max(startIndex - itemsPerPage, 0);
  setStartIndex(newStartIndex);
  setEndIndex(newStartIndex + itemsPerPage);
};

const handleNextPage = () => {
  const newStartIndex = endIndex;
  const newEndIndex = Math.min(endIndex + itemsPerPage, domains.length);
  setStartIndex(newStartIndex);
  setEndIndex(newEndIndex);
};
  
const toggleRowExpansion = (domainId) => {
  setExpandedRows((prevExpandedRows) => ({
    ...prevExpandedRows,
    [domainId]: !prevExpandedRows[domainId],
  }));
};

const isSmallScreen = window.innerWidth <= 768;


const applyBtnStyle = (isDisabled) => ({
  backgroundColor: isDisabled ? '#d3d3d3' : '#007bff',
  color: isDisabled ? '#6c757d' : '#fff',
  padding: '2px 4px',
  border: 'none',
  borderRadius: '5px',
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  textAlign: 'left'
});


  return (
    
    <div style={profileStyle}>
      
      {notification && (
        <Notification message={notification} duration={2000} onClose={() => setNotification(null)} />
      )}
      <div className="header-manage-domains">
        
    <div className="column-one">
    <div className="profile-container">
   
</div>

    </div>

    <div className="column-two-manage-domains">
  
    </div>
  
    <div className="column-three-manage-domains">
    <Link to="/marketplace" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'black' }}>
  <button style={{ marginRight: '15px', padding: '2px 4px', border: '1px solid black', borderRadius: '5px', background: 'transparent', cursor: 'pointer' }}>
    Job Posts
  </button>
</Link>

<Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'black' }}>
 {/* <button style={{ marginRight: '15px', padding: '2px 4px', border: '1px solid black', borderRadius: '5px', background: 'transparent', cursor: 'pointer' }}>
    Dashboard
  </button> */}
</Link>
<h4 ><button style={ logoutStyle } onClick={handleLogout}>Logout</button></h4>
      </div>
      
    </div>
    <div> <button style={addDomainbtnStyle} onClick={addDomain}>Add a new Job Post</button>

    <button
  style={startIndex <= 0 ? disabledPreNavButtonStyle : PreNavbuttonStyle}
  onClick={handlePreviousPage}
  disabled={startIndex <= 0}
>
  <Icon icon="carbon:previous-filled" color={startIndex <= 0 ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />

</button>

<button
  style={endIndex >= domains.length ? disabledNxtNavButtonStyle : NxtNavbuttonStyle}
  onClick={handleNextPage}
  disabled={endIndex >= domains.length}
>
  <Icon icon="carbon:next-filled" color={endIndex >= domains.length ? 'grey' : 'black'} width="24" height="24" style={NaviconStyle} />
</button>

    </div>
   

    <div>
    {isLoading && <LoadingSpinner />}

{!isLoading && (
  <>
{editingRowId === null && (
  
<table>
            <thead>
              <tr>
            <th>Organisation</th>
            <th>Job title</th>
            {isSmallScreen && <th style={thStyle}></th>}
            {!isSmallScreen && (
              <>
            <th>Annual Salary</th>           
            <th>Employment Type</th>
            <th>Industry</th>
            <th>Location</th>
            <th>Closing date</th>
            <th>Job link</th>
            <th>Post type</th>
            <th>Date listed</th>
            <th>Action</th>
            </>
            )}
              </tr>
            </thead>
            <tbody>
  {isLoading ? (
    <tr>
      <td colSpan={isSmallScreen ? '2' : '8'}><LoadingSpinner /></td>
    </tr>
  ) : (
    domainsToDisplay.map((domain) => {
      const rows = [
        <tr key={domain.id}>
          <td>{domain.organisationName}</td>
          <td>{domain.domainName}</td>
          {isSmallScreen && (
            <td style={tdStyle}>
              <button
  style={{
    backgroundColor: expandedRows[domain.id] ? 'blue' : 'blue',
    color: 'white',
    padding: '4px 8px',
    border: 'none',
    borderRadius: '5px',
  }}
  onClick={() => toggleRowExpansion(domain.id)}
>
  {expandedRows[domain.id] ? '-' : '+'}
</button>
            </td>
          )}
          {!isSmallScreen && (
            <>
              <td>{domain.currency}{domain.numeric}</td>
              <td>{domain.type}</td>
              <td>{domain.category}</td>
              <td>{domain.jobLocation}</td>
              <td>{domain.closingDate ? getFormattedDate(domain.closingDate) : "No date given"}</td>
              <td>
                {domain.jobUrl ? (
                  <a href={domain.jobUrl} target="_blank" rel="noopener noreferrer">Job Link</a>
                ) : (
                  'No Job Link'
                )}
              </td>
              <td>{domain.postType}</td>
              <td>{domain.dateListed}</td>
              <td>
              <button
  onClick={() => handleTogglePublicStatus(domain.id, domain.isPublic)}
  style={{
    backgroundColor: domain.isPublic ? 'green' : 'white',
    color: domain.isPublic ? 'white' : 'black',
    border: domain.isPublic ? 'none' : '1px solid black', // Fix here
    padding: '4px 8px',
    borderRadius: '5px',
    cursor: 'pointer',
    margin: '5px',
    fontSize: '12px',
  }}
>
  {domain.isPublic ? 'Published' : 'Publish'}
</button>
                <button style={editDomainbtnStyle} onClick={() => handleEditClick(domain)}>Edit</button>
                <button style={removeDomainbtnStyle} onClick={() => removeDomain(domain.id)}>Delete post</button>
              </td>
            </>
          )}
        </tr>
      ];

      // Add expanded row if applicable
      if (isSmallScreen && expandedRows[domain.id]) {
        rows.push(
          <tr key={`${domain.id}-expanded`}>
            <td colSpan="2">
              <div>
                <p style={{ color: 'grey', textAlign: 'center', lineHeight: '1.5' }}>
                  <strong>{domain.domainName}</strong>
                </p>
                <p><strong>Type:</strong> {domain.type}</p>
                <p><strong>Annual Salary:</strong> {domain.currency} {domain.numeric}</p>
                <p><strong>Industry:</strong> {domain.category}</p>
                <p><strong>Location:</strong> {domain.jobLocation}</p>
                <p><strong>Closing Date:</strong> {domain.closingDate ? getFormattedDate(domain.closingDate) : "No date given"}</p>
                <p>
                  <strong>View: </strong>
                  <a href={domain.jobUrl} target="_self" rel="noopener noreferrer">
                    <button style={applyBtnStyle(!domain.jobUrl)} disabled={!domain.jobUrl}>
                      Job Link
                    </button>
                  </a>
                </p>
                <p><button
                  onClick={() => handleTogglePublicStatus(domain.id, domain.isPublic)}
                  style={{
                    backgroundColor: domain.isPublic ? 'green' : 'white',
                    color: domain.isPublic ? 'white' : 'black',
                    border: domain.isPublic ? 'none' : '1px solid black', // Fix here
                    padding: '4px 8px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    margin: '5px',
                    fontSize: '12px',
                  }}
                >
                  {domain.isPublic ? 'Published' : 'Publish'}
                </button>
                <button style={editDomainbtnStyle} onClick={() => handleEditClick(domain)}>Edit</button>
                <button style={removeDomainbtnStyle} onClick={() => removeDomain(domain.id)}>Delete post</button></p>
                <p><strong>Organisation:</strong> {domain.organisationName}</p>
              </div>
            </td>
          </tr>
        );
      }

      return rows;
    })
  )}
</tbody>

          </table> 
   )}
    {editingRowId !== null && (
      <table>
       
        <thead>
          <tr>
            <th>Organisations edit</th>
            
          </tr>
        </thead>
        <tbody>
  {isLoading && (
    <tr>
      <td colSpan="7"><LoadingSpinner /></td>
    </tr>
  )}
  {!isLoading && showEmptyRow && (
    <tr>
       
    </tr>
  )}
  {!isLoading && renderTableRows()}
</tbody>

      </table>
 )}
     
     
      </>
  )}
    </div>
    
  </div>
  );
}

export default ManageDomains;
